import { useRecoilValue } from "recoil";
import { SecretNetworkClient, Coin } from "secretjs";

import { sleep } from "../utils/common";
import { configState } from "../context/configState";
import { sleepTime } from "../utils/constants";


export const useIbcTxnClient = () => {
  const { ibcChainInfo } = useRecoilValue(configState);

  const getTokenClient = async (tokenName: string) => {
    try {
      while (
        !(window as any).keplr ||
        !(window as any).getEnigmaUtils ||
        !(window as any).getOfflineSignerOnlyAmino
      ) {
        await sleep(sleepTime);
      }

      await (window as any).keplr.experimentalSuggestChain(
        ibcChainInfo[tokenName]
      );
      await (window as any).keplr.enable(ibcChainInfo[tokenName].chainId);

      const offlineSigner = (window as any).keplr.getOfflineSignerOnlyAmino(
        ibcChainInfo[tokenName].chainId
      );

      const [{ address }] = await offlineSigner.getAccounts();

      const wasmChainClient = new SecretNetworkClient({
        url: ibcChainInfo[tokenName].rest,
        chainId: ibcChainInfo[tokenName].chainId,
        wallet: offlineSigner,
        walletAddress: address,
      });

      const { balance } = await wasmChainClient.query.bank.balance({
        address: address,
        denom: ibcChainInfo[tokenName].stakeCurrency.coinMinimalDenom,
      });

      const amount: Coin = {
        amount: (balance?.amount !== undefined)? balance?.amount: "0",
        denom: ibcChainInfo[tokenName].stakeCurrency.coinMinimalDenom,
      }

      return { wasmChainClient, amount, address };
    } catch (error) {
      console.debug(error);
    }
  };

  return {
    getTokenClient,
  };
};
